import { authorizedRequest } from "../httprequests";

export function deleteLogout(refreshToken: string) {
  return authorizedRequest.delete(`/auth/logout/${refreshToken}`);
}
